import { BaseModel } from '../../../../../../../core/_base/crud';

    export class HangNhapKho extends BaseModel{
        IdTk: number
        IdCtnk: number
        IdNk: number
        SophieuNK: string
        IdKho: number
        TenKho: string
        ViTriKho: string
        IdHh: number
        MaHH: string
        TenHH: string
        IdLoaiHH: number
        TenLoaiHH: string
        IdNCC: number
        TenNCC: string
        IdLo: number
        Solo: string
        Ngaysanxuat: string
        Hansudung: string
        Soluong: number
        NgayNhapKho: string
        DaLapPhieuKiemTra: boolean
        QuyetDinhLoHang: string
        NguoiKiemTraSauNhapKho: number
        TenNguoiKiemTra: string
        IdDVT: number
        TenDVT: string
        SoMay: string
        MaSub: string

        idNhomHH: number
        isNLK: boolean
        isNLT: boolean
        isTPBTP: boolean
        isGroupSX: boolean
        isGroupQA: boolean

        clear(){
            this.IdTk = 0;
            this.IdCtnk = 0;
            this.IdNk = 0;
            this.SophieuNK = '';
            this.IdKho = 0;
            this.TenKho = '';
            this.ViTriKho = '';
            this.IdHh = 0;
            this.MaHH = '';
            this.TenHH = '';
            this.IdLoaiHH = 0;
            this.TenLoaiHH = '';
            this.IdNCC = 0;
            this.TenNCC = '';
            this.IdLo = 0;
            this.Solo = '';
            this.Ngaysanxuat = '';
            this.Hansudung = '';
            this.Soluong = 0;
            this.NgayNhapKho = '';
            this.DaLapPhieuKiemTra = false;
            this.QuyetDinhLoHang = '';
            this.NguoiKiemTraSauNhapKho = 0;
            this.TenNguoiKiemTra = '';
            this.IdDVT = 0;
            this.TenDVT = '';
            this.SoMay = '';
            this.MaSub = '';
            this.idNhomHH = 0;
            this.isNLK = false;
            this.isNLT = false;
            this.isTPBTP = false;
            this.isGroupSX = false;
            this.isGroupQA = false;
        }

        copy(item: HangNhapKho){
            
            this.IdTk = item.IdTk;
            this.IdCtnk =  item.IdCtnk;
            this.IdNk =  item.IdNk;
            this.SophieuNK =  item.SophieuNK;
            this.IdKho =  item.IdKho;
            this.TenKho =  item.TenKho;
            this.ViTriKho = item.ViTriKho;
            this.IdHh =  item.IdHh;
            this.MaHH =  item.MaHH;
            this.TenHH =  item.TenHH;
            this.IdLoaiHH =  item.IdLoaiHH;
            this.TenLoaiHH =  item.TenLoaiHH;
            this.IdNCC = item.IdNCC;
            this.TenNCC = item.TenNCC;
            this.IdLo =  item.IdLo;
            this.Solo =  item.Solo;
            this.Ngaysanxuat =  item.Ngaysanxuat;
            this.Hansudung =  item.Hansudung;
            this.Soluong =  item.Soluong;
            this.NgayNhapKho =  item.NgayNhapKho;
            this.DaLapPhieuKiemTra =  item.DaLapPhieuKiemTra;
            this.QuyetDinhLoHang =  item.QuyetDinhLoHang;
            this.NguoiKiemTraSauNhapKho = item.NguoiKiemTraSauNhapKho;
            this.TenNguoiKiemTra =  item.TenNguoiKiemTra;
            this.IdDVT = item.IdDVT;
            this.TenDVT = item.TenDVT;
            this.SoMay = item.SoMay;
            this.MaSub = item.MaSub;
            this.idNhomHH = item.idNhomHH;
            this.isNLK = item.isNLK;
            this.isNLT = item.isNLT;
            this.isTPBTP = item.isTPBTP;
            this.isGroupSX = item.isGroupSX;
            this.isGroupQA = item.isGroupQA;
        }
    }